export default __webpack_public_path__ + "static/media/MOTIVO_01.fa043734.jpg";